(function () {
  'use strict';
  function init(scope) {
    var catalog = scope.querySelector('[data-mi-hs-catalog]');
    if (!catalog || catalog.dataset.miHsFiltersBound) return;
    catalog.dataset.miHsFiltersBound = 'true';
    var form = catalog.querySelector('[data-mi-hs-filter]');
    var track = catalog.querySelector('[data-mi-hs-track]');
    var home = catalog.querySelector('.mi-hs-filter-home');
    var open = catalog.querySelector('[data-mi-hs-filter-open]');
    var sort = catalog.querySelector('[data-mi-hs-sort]');
    var min = form.elements.hs_min, max = form.elements.hs_max;
    var products = [], ceiling = 0, timer;
    var mobile = window.matchMedia('(max-width: 1000px)');
    var dialog = document.createElement('dialog');
    dialog.id = 'mi-hs-filter-dialog'; dialog.className = 'mi-hs-filter-dialog';
    dialog.setAttribute('aria-label', 'Filtros de Hot Sale');
    document.getElementById('root').appendChild(dialog);
    var brandNames = ['AFNAN','AHLI','ARMAF','BHARARA','BLACKOUD','DEVIER','DUMONT','EMPER','FRENCH AVENUE','GHETTO BY RYAN CASTRO','ILMIN','LATTAFA','MAISON ALHAMBRA','MOSCHINO','MUNDUS','RASASI','RAYHAAN','ZAKAT'];
    function normalize(text) { return String(text || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase(); }
    function profile(item) {
      var source = item.querySelector('[data-mi-hs-profile]'), data = source ? JSON.parse(source.textContent) : {};
      var tags = (data.tags || []).map(normalize);
      var genders = ['MUJER','HOMBRE','UNISEX'].filter(function (gender) { return tags.indexOf(gender) !== -1; });
      if (!genders.length) {
        var text = normalize(data.genero);
        if (/UNISEX/.test(text)) genders = ['MUJER','HOMBRE','UNISEX'];
        else { if (/FEMENINO|MUJER/.test(text)) genders.push('MUJER'); if (/MASCULINO|HOMBRE/.test(text)) genders.push('HOMBRE'); }
      }
      var notes = data.salida;
      if (!notes && data.notasHtml) {
        var clean = String(data.notasHtml).replace(/<\/(p|li|div|tr|h[1-6])>|<br\s*\/?\s*>/gi,'\n');
        var doc = new DOMParser().parseFromString(clean,'text/html');
        var text = doc.body.textContent.replace(/\u00a0/g,' ');
        var match = text.match(/(?:^|\n)\s*(?:notas?\s+(?:de\s+)?(?:salida|iniciales|apertura)|top notes)\s*:?\s*([^]+?)(?=\n\s*(?:notas?\s+(?:de\s+)?(?:coraz[oó]n|fondo|base)|concentraci[oó]n|familia)|$)/i);
        if (match && match[1].trim().length <= 650) notes = match[1].trim();
      }
      return { genders:genders, fragrances:window.MiFraganciaReglas ? window.MiFraganciaReglas.classify(notes) : [] };
    }
    function kind(item) { return item.dataset.miHsKind || (normalize(item.dataset.miHsTitle).indexOf('COMBO') === 0 ? 'combo' : 'perfume'); }
    function brands(item) {
      var found = brandNames.filter(function (brand) { return normalize(item.dataset.miHsTitle).indexOf(brand) !== -1; });
      var vendor = normalize(item.dataset.miHsBrand).trim();
      if (kind(item) === 'perfume' && vendor && vendor !== 'PERFUMERIA MILLENNIO') return [vendor];
      return found.length ? found : vendor ? [vendor] : [];
    }
    function presentation(item) {
      var value = item.dataset.miHsOption;
      if (!value || value === 'Default Title') {
        var label = item.querySelector('.mi-card__presentacion');
        value = label ? label.textContent : '';
      }
      var amounts = String(value).match(/\d+(?:[.,]\d+)?\s*ml/gi) || [];
      amounts = amounts.map(function (amount) { return amount.replace(/\s+/g,' ').toLowerCase(); });
      return amounts.length > 1 ? amounts.join(' + ') : amounts.length ? (kind(item) === 'combo' ? '2 × ' : '') + amounts[0] : 'Presentación única';
    }
    function checked(name) { return Array.from(form.querySelectorAll('input[name="' + name + '"]:checked'), function (input) { return input.value; }); }
    function state() {
      return { kinds: checked('hs_kind'), genders:checked('hs_gender'), fragrances:checked('hs_fragrance'), brands: checked('hs_brand'), sizes: checked('hs_size'), discount: checked('hs_discount')[0] || 'all', min: min.value === '' ? 0 : Number(min.value), max: max.value === '' ? ceiling : Number(max.value) };
    }
    function matches(product, filters, except) {
      return (except === 'hs_kind' || !filters.kinds.length || filters.kinds.indexOf(product.kind) !== -1) &&
        (except === 'hs_gender' || !filters.genders.length || filters.genders.some(function (gender) { return product.genders.indexOf(gender) !== -1; })) &&
        (except === 'hs_fragrance' || !filters.fragrances.length || filters.fragrances.some(function (fragrance) { return product.fragrances.indexOf(fragrance) !== -1; })) &&
        (except === 'hs_brand' || !filters.brands.length || filters.brands.some(function (brand) { return product.brands.indexOf(brand) !== -1; })) &&
        (except === 'hs_size' || !filters.sizes.length || filters.sizes.indexOf(product.size) !== -1) &&
        (except === 'hs_discount' || filters.discount === 'all' || product.discount >= Number(filters.discount)) &&
        product.price >= filters.min && product.price <= filters.max;
    }
    function options(name, values, radio, selected) {
      var list = form.querySelector('[data-mi-hs-options="' + name + '"]');
      list.replaceChildren();
      values.forEach(function (option, index) {
        var row = document.createElement('li'), input = document.createElement('input'), label = document.createElement('label');
        input.type = radio ? 'radio' : 'checkbox'; input.name = name; input.value = option.value;
        input.id = 'mi-' + name + '-' + index; input.checked = selected.indexOf(option.value) !== -1;
        label.htmlFor = input.id; label.textContent = option.label + ' ';
        var count = document.createElement('span'); count.dataset.miHsFacetCount = ''; label.appendChild(count);
        row.append(input, label); list.appendChild(row);
      });
    }
    function syncURL(mode) {
      var url = new URL(location.href);
      ['hs_kind','hs_gender','hs_fragrance','hs_brand','hs_size','hs_discount','hs_min','hs_max','hs_sort'].forEach(function (name) { url.searchParams.delete(name); });
      var filters = state();
      filters.genders.forEach(function (value) { url.searchParams.append('hs_gender',value); });
      filters.fragrances.forEach(function (value) { url.searchParams.append('hs_fragrance',value); });
      filters.kinds.forEach(function (value) { url.searchParams.append('hs_kind',value); });
      filters.brands.forEach(function (value) { url.searchParams.append('hs_brand',value); });
      filters.sizes.forEach(function (value) { url.searchParams.append('hs_size',value); });
      if (filters.discount !== 'all') url.searchParams.set('hs_discount',filters.discount);
      if (filters.min > 0) url.searchParams.set('hs_min',filters.min);
      if (filters.max < ceiling) url.searchParams.set('hs_max',filters.max);
      if (sort.value !== 'featured') url.searchParams.set('hs_sort',sort.value);
      if (url.href !== location.href) history[mode === 'replace' ? 'replaceState' : 'pushState'](null,'',url.href);
    }
    function readURL() {
      var params = new URL(location.href).searchParams;
      ['hs_kind','hs_gender','hs_fragrance','hs_brand','hs_size','hs_discount'].forEach(function (name) {
        var chosen = params.getAll(name);
        form.querySelectorAll('input[name="' + name + '"]').forEach(function (input) { input.checked = chosen.indexOf(input.value) !== -1 || (name === 'hs_discount' && !chosen.length && input.value === 'all'); });
      });
      min.value = params.get('hs_min') || '0'; max.value = params.get('hs_max') || String(ceiling);
      var wanted = params.get('hs_sort') || 'featured';
      sort.value = Array.from(sort.options).some(function (option) { return option.value === wanted; }) ? wanted : 'featured';
      form.querySelectorAll('[name="hs_sort"]').forEach(function (input) { input.checked = input.value === sort.value; });
    }
    function syncSort() {
      var selected = sort.options[sort.selectedIndex];
      Array.from(sort.options).forEach(function (option) { option.toggleAttribute('selected',option === selected); });
      var wrapper = sort.closest('.select-wrapper');
      if (wrapper && selected) {
        wrapper.classList.add('done');
        var label = wrapper.querySelector('.bv_atual .sl_inner');
        if (label) label.textContent = selected.textContent;
        wrapper.querySelectorAll('.bv_ul_inner .li:not(.nofocus)').forEach(function (row) {
          var text = row.querySelector('.text'); row.classList.toggle('bv_selected',!!text && text.textContent.trim() === selected.textContent.trim());
        });
      }
      form.querySelectorAll('[name="hs_sort"]').forEach(function (input) { input.checked = input.value === sort.value; });
    }
    function render(historyMode) {
      syncSort();
      var filters = state();
      min.setCustomValidity(''); max.setCustomValidity('');
      if (filters.min > filters.max) max.setCustomValidity('El precio máximo debe ser igual o mayor al mínimo.');
      if (!min.checkValidity() || !max.checkValidity()) {
        form.querySelector('[data-mi-hs-filter-status]').textContent = 'Revisa el rango de precios: el máximo debe ser igual o mayor al mínimo.';
        return;
      }
      var ordered = products.slice();
      ordered.sort(function (a,b) {
        switch (sort.value) {
          case 'price-ascending': return a.price - b.price || a.order - b.order;
          case 'price-descending': return b.price - a.price || a.order - b.order;
          case 'discount': return b.discount - a.discount || a.order - b.order;
          case 'title': return a.title.localeCompare(b.title,'es') || a.order - b.order;
          // Destacados: todos los combos primero, conservando el orden propio
          // de cada grupo. Los órdenes elegidos por el cliente siguen intactos.
          default: return Number(b.kind === 'combo') - Number(a.kind === 'combo') || a.order - b.order;
        }
      });
      var found = 0;
      ordered.forEach(function (product) { product.item.hidden = !matches(product,filters); if (!product.item.hidden) found++; track.appendChild(product.item); });
      catalog.querySelector('[data-mi-hs-count]').textContent = found + (found === 1 ? ' producto' : ' productos');
      catalog.querySelector('[data-mi-hs-no-results]').hidden = found !== 0;
      form.querySelector('[data-mi-hs-filter-status]').textContent = found + (found === 1 ? ' producto encontrado.' : ' productos encontrados.');
      form.querySelector('[data-mi-hs-apply]').textContent = 'Ver productos (' + found + ')';
      form.querySelectorAll('[data-mi-hs-options] input').forEach(function (input) {
        var group = input.name;
        var count = products.filter(function (product) {
          if (!matches(product,filters,group)) return false;
          if (group === 'hs_kind') return product.kind === input.value;
          if (group === 'hs_gender') return product.genders.indexOf(input.value) !== -1;
          if (group === 'hs_fragrance') return product.fragrances.indexOf(input.value) !== -1;
          if (group === 'hs_brand') return product.brands.indexOf(input.value) !== -1;
          if (group === 'hs_size') return product.size === input.value;
          return input.value === 'all' || product.discount >= Number(input.value);
        }).length;
        input.nextElementSibling.querySelector('[data-mi-hs-facet-count]').textContent = '(' + count + ')';
        input.disabled = !count && !input.checked;
      });
      if (historyMode) syncURL(historyMode);
    }
    function collect() {
      var items = Array.from(track.children);
      if (items.length === products.length && items.every(function (item) { return products.some(function (p) { return p.item === item; }); })) return;
      products = items.map(function (item,index) {
        var data = profile(item);
        var title = item.dataset.miHsTitle || '', price = Number(item.dataset.miHsPrice), compare = Number(item.dataset.miHsCompare);
        return { item:item, title:title, price:price, discount:compare > price ? Math.round((compare-price)*100/compare) : 0, kind:kind(item), genders:data.genders, fragrances:data.fragrances, brands:brands(item), size:presentation(item), order:index };
      });
      ceiling = Math.max.apply(null,products.map(function (p) { return p.price; }).concat([0]));
      max.max = ceiling; max.placeholder = String(ceiling);
      var availableBrands = Array.from(new Set(products.reduce(function (list,product) { return list.concat(product.brands); },[]))).sort(function (a,b) { return a.localeCompare(b,'es'); });
      var sizes = Array.from(new Set(products.map(function (p) { return p.size; }))).sort();
      options('hs_kind',[{value:'perfume',label:'Perfumes'},{value:'combo',label:'Combos'}],false,checked('hs_kind'));
      options('hs_gender',['MUJER','HOMBRE','UNISEX'].map(function (value) { return {value:value,label:value}; }),false,checked('hs_gender'));
      var fragrances = Array.from(new Set(products.reduce(function (list,product) { return list.concat(product.fragrances); },[]))).sort(function (a,b) { return a.localeCompare(b,'es'); });
      options('hs_fragrance',fragrances.map(function (value) { return {value:value,label:value.toUpperCase()}; }),false,checked('hs_fragrance'));
      options('hs_brand',availableBrands.map(function (value) { return {value:value,label:value}; }),false,checked('hs_brand'));
      options('hs_size',sizes.map(function (value) { return {value:value,label:value}; }),false,checked('hs_size'));
      var discounts = [{value:'all',label:'Todos'}].concat([1,10,20,30,40,50].filter(function (threshold) { return products.some(function (p) { return p.discount >= threshold; }); }).map(function (threshold) { return {value:String(threshold),label:threshold === 1 ? 'Con descuento' : 'Desde ' + threshold + '%'}; }));
      options('hs_discount',discounts,true,checked('hs_discount'));
      readURL(); render();
    }
    function close() { if (dialog.open) dialog.close(); }
    open.addEventListener('click',function () {
      dialog.appendChild(form); dialog.showModal(); open.setAttribute('aria-expanded','true');
      document.documentElement.classList.add('mi-hs-filters-open');
      form.querySelector('[data-mi-hs-close]').focus();
    });
    dialog.addEventListener('close',function () { home.appendChild(form); open.setAttribute('aria-expanded','false'); document.documentElement.classList.remove('mi-hs-filters-open'); open.focus(); });
    dialog.addEventListener('click',function (event) { if (event.target === dialog) close(); });
    form.addEventListener('click',function (event) {
      var clear = event.target.closest('[data-mi-hs-clear]'), finish = event.target.closest('[data-mi-hs-close]');
      if (!clear && !finish) return;
      event.preventDefault(); event.stopImmediatePropagation();
      if (finish) { clearTimeout(timer); render('push'); if (min.checkValidity() && max.checkValidity()) close(); return; }
      form.querySelectorAll('[name="hs_kind"],[name="hs_gender"],[name="hs_fragrance"],[name="hs_brand"],[name="hs_size"]').forEach(function (input) { input.checked = false; });
      form.querySelectorAll('[name="hs_discount"]').forEach(function (input) { input.checked = input.value === 'all'; });
      min.value = '0'; max.value = String(ceiling); render('push');
    },true);
    form.addEventListener('submit',function (event) { event.preventDefault(); render('push'); });
    form.addEventListener('change',function (event) {
      if (event.target.name === 'hs_sort') sort.value = event.target.value;
      clearTimeout(timer); render('push');
    });
    form.addEventListener('input',function (event) { if (event.target === min || event.target === max) { clearTimeout(timer); timer = setTimeout(function () { render('replace'); },350); } });
    // The theme's custom select emits change before updating its native value.
    sort.addEventListener('change',function () { window.requestAnimationFrame(function () { sort = catalog.querySelector('[data-mi-hs-sort]'); render('push'); }); });
    mobile.addEventListener('change',function () { if (!mobile.matches) close(); });
    window.addEventListener('popstate',function () { readURL(); render(); });
    track.addEventListener('click',function (event) {
      var chip = event.target.closest('[data-mi-talla]');
      if (!chip || chip.disabled) return;
      window.requestAnimationFrame(function () {
        var item = chip.closest('.mi-hs-products__item');
        var product = products.find(function (entry) { return entry.item === item; });
        if (!product) return;
        function pesos(value) { return Number(String(value || '').replace(/[^0-9]/g,'')); }
        product.price = pesos(chip.dataset.miPrecio);
        var comparison = Number(item.dataset.miHsCompare);
        product.discount = comparison > product.price ? Math.round((comparison-product.price)*100/comparison) : 0;
        item.dataset.miHsOption = chip.dataset.miPresentacion || chip.textContent.trim();
        product.size = presentation(item);
        var oldCeiling = ceiling;
        ceiling = Math.max.apply(null,products.map(function (entry) { return entry.price; }).concat([0]));
        max.max = ceiling; max.placeholder = String(ceiling);
        if (Number(max.value) === oldCeiling) max.value = String(ceiling);
        var sizes = Array.from(new Set(products.map(function (entry) { return entry.size; }))).sort();
        options('hs_size',sizes.map(function (value) { return {value:value,label:value}; }),false,checked('hs_size'));
        render('replace');
      });
    });
    new MutationObserver(collect).observe(track,{childList:true});
    collect();
    window.dispatchEvent(new CustomEvent('mobileFilters'));
    // Native filter accordion styling is reused; these filters never submit to Shopify.
    form.querySelectorAll('.f8fl-toggle').forEach(function (control) { control.setAttribute('aria-controls','mi-hs-filter-dialog'); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',function () { init(document); }); else init(document);
  document.addEventListener('shopify:section:load',function (event) { init(event.target); });
})();
